import { Input, Col } from 'design-react-kit/dist/design-react-kit';
import { defineMessages, useIntl } from 'react-intl';
import { useEffect, useState } from 'react';

const messages = defineMessages({
  periodFromLabel: {
    id: 'Periodo dal *',
    defaultMessage: 'Periodo dal *',
  },
  afterDateError: {
    id: '* La data deve essere maggiore di:',
    defaultMessage: '* La data deve essere maggiore di:',
  },
  beforeDateError: {
    id: '* La data deve essere antecedente a:',
    defaultMessage: '* La data deve essere antecedente a:',
  },
  and: {
    id: 'e',
    defaultMessage: 'e',
  },
  requiredField: {
    id: '* Campo obbligatorio',
    defaultMessage: '* Campo obbligatorio',
  },
  daysExceeded: {
    id: "* L'intervallo tra le date non può superare",
    defaulMessage: "* L'intervallo tra le date non può superare",
  },
  days: {
    id: 'giorni',
    defaulMessage: 'giorni',
  },
});

const StartDateField = ({ data, formData, setFormData, endDate, error, setError }) => {
  const intl = useIntl();

  let format = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  const [formMinDate, setFormMinDate] = useState();
  const [formMaxDate, setFormMaxDate] = useState();
  const [inputValue, setInputValue] = useState();

  useEffect(() => {
    setFormMinDate(new Date(data.minDate).toLocaleDateString('it-IT', format));
    setFormMaxDate(new Date(data.maxDate).toLocaleDateString('it-IT', format));
  }, [data.minDate, data.maxDate]);

  // calculate days between dates
  const getDaysDifference = (date1, date2) => {
    const diffTime = Math.abs(date2 - date1);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  /**
   * validation of date
   */
  const dateValidator = e => {
    if (e) {
      const { name, value } = e.target;
      setInputValue(e);
      if (name) {
        const MinDate = new Date(data.minDate);
        const MaxDate = new Date(data.maxDate);
        const StartDate = new Date(value);
        const EndDate = new Date(formData?.endDate);
        const currentFormEndDate = new Date(formData?.endDate).toLocaleDateString('it-IT', format);

        if (StartDate != formData?.startDate) {
          setFormData(formData => ({
            ...formData,
            [name]: StartDate,
          }));
        }

        if (isNaN(StartDate?.getTime())) {
          setError(intl.formatMessage(messages.requiredField));
        } else if (!isNaN(EndDate?.getTime()) && StartDate > EndDate) {
          setError(`${intl.formatMessage(messages.beforeDateError)} ${currentFormEndDate}`);
        } else if (StartDate < MinDate) {
          setError(`${intl.formatMessage(messages.afterDateError)} ${formMinDate}`);
        } else if (StartDate > MaxDate) {
          setError(`${intl.formatMessage(messages.beforeDateError)} ${formMaxDate}`);
        } else if (data.maxDays && getDaysDifference(StartDate, EndDate) > data.maxDays) {
          setError(
            `${intl.formatMessage(messages.daysExceeded)} ${data.maxDays} ${intl.formatMessage(
              messages.days
            )}`
          );
        } else {
          setError('');
        }
      }
    }
  };

  useEffect(() => {
    if (endDate > formData?.endDate || endDate < formData?.endDate) {
      if (inputValue) {
        dateValidator(inputValue);
      } else if (formData.startDate) {
        dateValidator({
          target: {
            name: 'startDate',
            value: formData.startDate,
          },
        });
      }
    }
  }, [formData?.endDate]);

  return (
    <Col md={6}>
      <Input
        type="date"
        id="startDate"
        name="startDate"
        label={intl.formatMessage(messages.periodFromLabel)}
        onChange={dateValidator}
        placeholder="dd/mm/yyyy"
        min={data?.minDate}
        max={data?.maxDate}
        value={!formData?.startDate ? '' : inputValue?.value}
        required
        className="mb-0"
      />
      {error && (
        <label color="danger" htmlFor="startDate-field" className="mt-0 text-danger lh-1 word-wrap">
          <small>{error}</small>
        </label>
      )}
    </Col>
  );
};

export default StartDateField;
